import styled from 'styled-components';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const SectionContainer = styled(Flex)`
  width: 100%;
  position: relative;
  background: #6c90a8;
  padding: calc(${themeSpace(8)}+ ${themeSpace(5)}) 0;
  min-height: 819px;
  ${themeMediaQuery('sm')} {
    min-height: 655px;
  }
  ${themeMediaQuery('tablet')} {
    min-height: 892px;
  }
`;

export const TextPairingContainer = styled(TextPairing)`
  .text-pairing-body {
    max-width: 420px;
    ${themeMediaQuery('below_sm')} {
      max-width: 288px;
    }
  }
  .text-pairing-eyebrow {
    margin-bottom: ${themeSpace(5)};
  }
  .text-pairing-title {
    max-width: 282px;
    font-size: ${themeSpace(8)};
    line-height: ${themeSpace(9)};

    ${themeMediaQuery('sm')} {
      max-width: 350px;
      font-size: calc(${themeSpace(8)} + ${themeSpace(5)});
      line-height: calc(${themeSpace(10)} + ${themeSpace(4)});
    }
  }
`;

export const VideoWrapper = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  ${themeMediaQuery('tablet')} {
    left: 24%;
    width: 50%;
  }
`;

export const StyledBox = styled(Box)`
  left: 12%;
  top: 10%;
  z-index: 10;
  position: absolute;
  ${themeMediaQuery('below_sm')} {
    left: 0;
    top: 6%;
    padding-left: ${themeSpace(7)};
  }
  ${themeMediaQuery('tablet')} {
    left: 28%;
  }
`;

export const DisplayAboveMobile = styled(Box)`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;
export const DisplayOnMobile = styled(Box)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;
